import { useState } from "react";
import { api } from "../api";
import { IconLogo } from "../components/icons";
import type { AuthUser } from "../types";

export function LoginPage({ onSignedIn }: { onSignedIn: (u: AuthUser) => void }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      onSignedIn(await api.login(login, password));
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setPassword("");
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">
          <span className="logo-mark"><IconLogo /></span>
          <span>ELG Meeting Hub</span>
        </div>
        <h1>Вход</h1>
        <p className="muted small" style={{ marginTop: -6, marginBottom: 20 }}>
          Доступ выдаёт администратор. Самостоятельной регистрации нет.
        </p>

        <div className="field">
          <label htmlFor="login">Логин</label>
          <input
            id="login"
            autoFocus
            autoComplete="username"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label htmlFor="password">Пароль</label>
          <div className="row" style={{ flexWrap: "nowrap" }}>
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="sm ghost nowrap"
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? "Скрыть" : "Показать"}
            </button>
          </div>
        </div>

        {error && <div className="banner red" style={{ marginBottom: 14 }}>{error}</div>}

        <button className="primary" type="submit" disabled={busy} style={{ width: "100%" }}>
          {busy && <span className="spinner" />} Войти
        </button>
      </form>
    </div>
  );
}
